import { SlackSenderLayout } from "../SlackSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SlackSenderEntities } from "../SlackSenderEntities";
import { SlackSenderRouterProps } from "../SlackSenderRouterProps";

export interface IProviderPageProps extends NSARouterMakerResult, SlackSenderRouterProps { }

function ProviderViewPage(props: IProviderPageProps)
{
	return (
		<SlackSenderLayout {...props}
			action={{
				description: "This section displays detailed information about a selected Slack provider, including its configuration and connected channel."
			}}
			pages={{
				entity: SlackSenderEntities.provider(props),
				view: {}
			}}>
			<></>
		</SlackSenderLayout>
	);
}

export default ProviderViewPage;